import { render, staticRenderFns } from "./videoPlayer.vue?vue&type=template&id=4f2967a2"
import script from "./videoPlayer.vue?vue&type=script&lang=ts"
export * from "./videoPlayer.vue?vue&type=script&lang=ts"
import style0 from "./videoPlayer.vue?vue&type=style&index=0&id=4f2967a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports